module.exports = __webpack_public_path__ + "img/20200512_163525.55f1591c.jpg";